
<span>
    {{ message() | translate }}
</span>

<img src="../../../../assets/images/icons/close.svg" alt="X" width="24" height="24" (click)="doClose()">
